'use client';

import { useEffect, useState } from 'react';

import { SystemNotificationV1 } from '@/shared/api';
import { getLogger } from '@/shared/utils/logger/client';

const logger = getLogger();

import { getSystemAlerts } from './action/get-system-alerts';

export const useSystemAlerts = () => {
	const [alerts, setAlerts] = useState<SystemNotificationV1[]>([]);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		const fetchAlerts = async () => {
			try {
				const data = await getSystemAlerts();
				// Возвращаем все алерты без фильтрации
				setAlerts(data.notifications);
			} catch (error) {
				logger.error('Failed to fetch system alerts', error);
			} finally {
				setIsLoading(false);
			}
		};

		fetchAlerts();
	}, []);

	const removeAlert = (alertId: string) => {
		setAlerts((prevAlerts) =>
			prevAlerts.filter((alert) => alert.id !== alertId),
		);
	};

	const shouldRender = !isLoading && alerts.length > 0;

	return {
		alerts,
		isLoading,
		shouldRender,
		removeAlert,
	};
};
